import React, { useState, useEffect } from 'react';
import { Form, Button, InputGroup, FormControl, Card, Row, Col, Spinner, Table } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone'; // React Dropzone import
import avatarImg from 'assets/img/team/avatar.png';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { useAuthWizardContext } from 'providers/AuthWizardProvider';

import 'react-toastify/dist/ReactToastify.css'; // 추가
import 'safedb/common/css/IniCustomCss.css';
import CheckOutModal from 'components/modal/CheckOutModal';
import { AiFillCloseCircle } from 'react-icons/ai';
import {
  handleValueDelete,
  goToParentPath,
  formatDate,
  formatPhoneNumber,
  validatePhoneNumber,
  handlePhoneChange
} from 'components/common/SunnyUtils';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';
import { useAppContext } from 'providers/AppProvider';
import { fetchCompanyInfo, fetchPricingPolicy, updateCompanyInfo, ImagesUpload_Site, fetchImageByUuid } from 'hooks/CallApi';
import styled from 'styled-components';

const InfoContainer = styled.div`
  padding: 1.5rem 2rem;
  max-width: 1400px;
  margin: 0 auto;
`;

const StyledCard = styled(Card)`
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.02);
  overflow: hidden;
  margin-bottom: 24px;
`;

const CardHeader = styled(Card.Header)`
  background-color: transparent;
  border-bottom: 1px solid #f1f5f9;
  padding: 1.25rem 1.5rem;
  font-weight: 700;
  color: #1e293b;
`;

// UUID 형태인지 판별하는 함수
const isValidUUID = (str) => {
  if (!str || typeof str !== 'string') return false;
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
};

const SiteInfo = ({ setValue }) => {
  const [modalConfirmShow, setModalConfirmShow] = useState(false);
  const [modalConfirmCheckShow, setModalConfirmCheckShow] = useState(false);
  const [isChevronUp, setIsChevronUp] = useState(false); // 상태 변수 추가
  const toggleKeyPart = () => {
    setKeyPart(!KeyPart);
    setIsChevronUp(!isChevronUp); // 아이콘 상태 전환
  };
  const [KeyPart, setKeyPart] = useState(true);
  const [NameError, setNameError] = useState('');
  const [NameBlankError, setNameBlankError] = useState(false);
  const [DescError, setDescError] = useState('');
  const [MailError, setMailError] = useState('');
  const [AddrError, setAddrError] = useState('');
  const [isHovered, setIsHovered] = useState(false);
  const [resultShow, setResultShow] = useState(false);
  const [originalEmailDomain, setOriginalEmailDomain] = useState(''); // 원본 이메일 도메인

  // 요금정책 관련 상태 추가
  const [policyDetails, setPolicyDetails] = useState(null);
  const [loadingPolicyDetails, setLoadingPolicyDetails] = useState(false);
  const [pricingPolicyUuid, setPricingPolicyUuid] = useState('');
  const [pricingPolicyName, setPricingPolicyName] = useState('');

  const handleMouseEnter = () => {
    if (userAuth === 'SA' || userAuth === 'ADMIN') {
      setIsHovered(true);
    }
  };
  const handleMouseLeave = () => setIsHovered(false);
  const [isInvalid, setIsInvalid] = useState(false); // 유효성 검사 상태
  const [PhoneError, setPhoneError] = useState(''); // 연락처 에러 메시지

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const {
    config: { checkorg, userAuth, checkorg_companyId },
    setConfig
  } = useAppContext();

  // 내용 변경 시 변경 버튼 눌렀을때
  const handleSubmitClick = () => {
    setModalConfirmShow(true);
  };

  const handleConfirm = async () => {
    try {
      const response = await updateCompanyInfo(checkorg_companyId, {
        imgUrl: formData.imgUrl,
        name: formData.clientName,
        tel: formData.clientPhone,
        email: formData.clientEmail,
        address: formData.clientAddress,
        description: formData.description
      });

      if (response) {
        setModalConfirmShow(false);
        // 변경 성공 시 기본 인증키 메뉴로 이동
        navigate('/safedb/common/key/apikey', { replace: true });
      } else {
        alert('회사 정보 업데이트가 실패했습니다.');
      }
    } catch (error) {
      console.error('회사 정보 업데이트 에러:', error);
      alert('회사 정보 업데이트 중 오류가 발생했습니다.');
    }
  };
  const navigate = useNavigate();

  const initialFormData = {
    createdAt: '', //queryParams.get('createdAt'),
    updateAt: '',
    clientName: '', //queryParams.get('clientName'),
    clientEmail: '', //queryParams.get('clientEmail'),
    clientPhone: '', //queryParams.get('clientPhone'),
    clientAddress: '', //queryParams.get('clientAddress'),
    description: '',
    clientSecret: '',
    clientKey: '',
    clientIV: '',
    imgUrl: ''
  };

  const [formData, setFormData] = useState({
    createdAt: '', //queryParams.get('createdAt'),
    updateAt: '',
    clientName: checkorg,
    clientEmail: '', //queryParams.get('clientEmail'),
    clientPhone: '', //queryParams.get('clientPhone'),
    clientAddress: '', //queryParams.get('clientAddress'),
    description: '',
    clientSecret: '',
    clientKey: '',
    clientIV: '',
    imgUrl: ''
  });
  const { user } = useAuthWizardContext();

  const [avatar, setAvatar] = useState([{ src: '' }]);
  const [currentBlobUrl, setCurrentBlobUrl] = useState(null); // Blob URL 관리용

  useEffect(() => {
    const loadCompanyInfo = async () => {
      try {
        const response = await fetchCompanyInfo(checkorg_companyId);
        const data = response.data;

        setFormData({
          createdAt: data.insertTimeUtc
            ? formatDate(data.insertTimeUtc) // 포맷 함수 호출
            : '-',
          updateAt: data.updateTimeUtc
            ? formatDate(data.updateTimeUtc) // 포맷 함수 호출
            : '-',
          clientName: data.name || '',
          clientEmail: data.email || '',
          clientPhone: data.tel || '',
          clientAddress: data.address || '',
          description: data.description || '',
          clientSecret: data.secret || '',
          clientKey: data.key || '',
          clientIV: data.iv || '',
          imgUrl: data.imgUrl
        });

        // 원본 이메일 도메인 저장
        if (data.email) {
          const emailParts = data.email.split('@');
          if (emailParts.length > 1) {
            setOriginalEmailDomain(emailParts[1]);
          }
        }

        // 요금정책 정보 설정
        if (data.pricingPolicyUuid) {
          setPricingPolicyUuid(data.pricingPolicyUuid);
          setPricingPolicyName(data.pricingPolicyName || '');
          // 요금정책 상세 정보 로드
          loadPolicyDetails(data.pricingPolicyUuid);
        }
      } catch (error) {
        alert('회사 정보를 불러오는 데 실패했습니다.');
      }
    };

    if (checkorg_companyId) {
      loadCompanyInfo();
    } else {
      alert('유효하지 않은 회사 ID입니다.');
    }
  }, [checkorg_companyId]);

  // 요금정책 상세 정보 로드 함수
  const loadPolicyDetails = async (policyUuid) => {
    if (!policyUuid) return;

    setLoadingPolicyDetails(true);
    try {
      const response = await fetchPricingPolicy(policyUuid);
      if (response && response.data) {
        setPolicyDetails(response.data);
      }
    } catch (error) {
      console.error("요금정책 정보 로딩 에러:", error);
    } finally {
      setLoadingPolicyDetails(false);
    }
  };

  // 통화 포맷 함수
  const formatCurrency = (amount) => {
    if (amount === undefined || amount === null) return '-';
    return new Intl.NumberFormat('ko-KR', { style: 'currency', currency: 'KRW' }).format(amount);
  };

  const calculateTotalCompensation = () => {
    if (!policyDetails) return 0;
    let total = parseFloat(policyDetails.compensationAmount) || 0;
    if (policyDetails.serviceGroupList) {
      policyDetails.serviceGroupList.forEach(group => {
        total += parseFloat(group.compensationAmount) || 0;
        if (group.servicePriceList) {
          group.servicePriceList.forEach(price => {
            total += parseFloat(price.compensationAmount) || 0;
          });
        }
      });
    }
    return total;
  };

  const hasAnyCompensation = () => {
    if (!policyDetails) return false;
    if (parseFloat(policyDetails.compensationAmount) > 0) return true;
    if (policyDetails.serviceGroupList) {
      return policyDetails.serviceGroupList.some(group => {
        if (parseFloat(group.compensationAmount) > 0) return true;
        return group.servicePriceList?.some(price => parseFloat(price.compensationAmount) > 0);
      });
    }
    return false;
  };

  useEffect(() => {
    const loadImage = async () => {
      // 기존 blob URL이 있으면 정리
      if (currentBlobUrl) {
        URL.revokeObjectURL(currentBlobUrl);
        setCurrentBlobUrl(null);
      }

      if (!formData.imgUrl || formData.imgUrl.trim() === '') {
        // 이미지 URL이 없으면 기본 이미지 사용
        setAvatar([{ src: avatarImg }]);
        return;
      }

      // UUID 형태인지 확인
      if (isValidUUID(formData.imgUrl)) {
        try {
          // UUID인 경우 API를 통해 이미지 데이터 가져오기
          const imageUrl = await fetchImageByUuid(formData.imgUrl);
          if (imageUrl) {
            setAvatar([{ src: imageUrl }]);
            setCurrentBlobUrl(imageUrl); // Blob URL 저장
          } else {
            // API 호출 실패 시 기본 이미지 사용
            setAvatar([{ src: avatarImg }]);
          }
        } catch (error) {
          console.error('UUID 이미지 로딩 실패:', error);
          // 에러 발생 시 기본 이미지 사용
          setAvatar([{ src: avatarImg }]);
        }
      } else {
        // 일반 URL 형태라면 그대로 사용
        setAvatar([{ src: formData.imgUrl }]);
      }
    };

    loadImage();
  }, [formData.imgUrl]);

  // Blob URL 정리용 useEffect (컴포넌트 언마운트 시)
  useEffect(() => {
    return () => {
      if (currentBlobUrl) {
        URL.revokeObjectURL(currentBlobUrl);
      }
    };
  }, [currentBlobUrl]);

  const handleChange = e => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

    // 각각의 에러
    if (name === 'clientEmail') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const koreanRegex = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; // 한글을 포함하는지 확인하는 정규식

      // 도메인 변경 검사 - 가장 먼저 체크
      if (value && originalEmailDomain) {
        const emailParts = value.split('@');
        if (emailParts.length > 1) {
          const currentDomain = emailParts[1];
          if (currentDomain !== originalEmailDomain) {
            setMailError('도메인은 변경할 수 없습니다.');
          } else if (!emailRegex.test(value)) {
            setMailError('올바른 이메일 형식이 아닙니다.');
          } else if (koreanRegex.test(value)) {
            setMailError('이메일에 한글을 포함할 수 없습니다.');
          } else if (value.length >= 50) {
            setMailError('고객사 메일은 최대 50자까지 입력 가능합니다.');
          } else {
            setMailError('');
          }
        } else {
          // @ 기호가 없거나 잘못된 형식인 경우
          if (!emailRegex.test(value)) {
            setMailError('올바른 이메일 형식이 아닙니다.');
          } else if (koreanRegex.test(value)) {
            setMailError('이메일에 한글을 포함할 수 없습니다.');
          } else if (value.length >= 50) {
            setMailError('고객사 메일은 최대 50자까지 입력 가능합니다.');
          } else {
            setMailError('');
          }
        }
      } else {
        // 원본 도메인이 없거나 입력값이 없는 경우 기본 검증
        if (!emailRegex.test(value)) {
          setMailError('올바른 이메일 형식이 아닙니다.');
        } else if (koreanRegex.test(value)) {
          setMailError('이메일에 한글을 포함할 수 없습니다.');
        } else if (value.length >= 50) {
          setMailError('고객사 메일은 최대 50자까지 입력 가능합니다.');
        } else {
          setMailError('');
        }
      }
    }

    if (name === 'clientName') {
      if (value.length >= 50) {
        setNameError(`고객사명은 최대 50자까지 입력 가능합니다.`);
      } else {
        setNameError('');
      }
    }

    if (name === 'clientAddress') {
      if (value.length >= 100) {
        setAddrError(`고객사 주소는 최대 100자까지 입력 가능합니다.`);
      } else {
        setAddrError('');
      }
    }

    if (name === 'description') {
      if (value.length >= 800) {
        setDescError(`고객사 설명란 입력은 최대 800자까지 입력 가능합니다.`);
      } else {
        setDescError('');
      }
    }

    if (name === 'clientPhone') {
      handlePhoneChange(value, formData, setFormData, setPhoneError, setIsInvalid);
      return; // 다른 입력 필드 검사를 건너뛴다.
    }
  };

  const handleComboChange = ({ target }) => {
    let name = target.name;
    let value = name === 'allDay' ? target.checked : target.value;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = e => {
    e.preventDefault();
  };



  const [uploading, setUploading] = useState(false);
  const onDrop = async acceptedFiles => {
    if (!(userAuth === 'SA' || userAuth === 'ADMIN')) return;
    if (!acceptedFiles || acceptedFiles.length === 0 || uploading) return; // 업로드 중복 방지
    const imageFile = acceptedFiles[0];
    try {
      setUploading(true);
      // 미리보기 즉시 반영
      const previewUrl = URL.createObjectURL(imageFile);
      setAvatar([{ src: previewUrl }]);
      // 회사 이미지 업로드 (공용 영역 전용 API)
      const uploadResponse = await ImagesUpload_Site(imageFile, 'company');
      const uploadedUrl = uploadResponse?.data?.imageUrl || uploadResponse?.imageUrl || '';
      if (!uploadedUrl) throw new Error('이미지 URL이 응답에 없습니다.');
      setFormData(prev => ({ ...prev, imgUrl: uploadedUrl }));
    } catch (e) {
      console.error('회사 이미지 업로드 실패:', e);
      alert('회사 이미지 업로드에 실패했습니다.');
    } finally {
      setUploading(false);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': ['.jpeg', '.jpg'],
      'image/png': ['.png'],
      'image/gif': ['.gif'],
      'image/svg+xml': ['.svg']
    },
    disabled: !(userAuth === 'SA' || userAuth === 'ADMIN') || uploading // 권한 없거나 업로드 중일 때
  });

  const isFormValid = () => {
    if (userAuth === 'MANAGER') {
      return false;
    }
    const requiredFields = [
      'clientName',
      'clientPhone',
      'clientEmail',
      'clientAddress'
    ];
    const allRequiredFieldsFilled = requiredFields.every(
      field => formData[field]?.trim().length > 0
    );
    const isFormChanged = Object.keys(formData).some(
      key => formData[key] !== initialFormData[key]
    );

    const phoneValidation = validatePhoneNumber(formData.clientPhone);

    // 도메인 변경 검사
    let isDomainChanged = false;
    if (formData.clientEmail && originalEmailDomain) {
      const emailParts = formData.clientEmail.split('@');
      if (emailParts.length > 1) {
        const currentDomain = emailParts[1];
        isDomainChanged = currentDomain !== originalEmailDomain;
      }
    }

    return allRequiredFieldsFilled && isFormChanged && phoneValidation.isValid && !isDomainChanged;

  };
  return (
    <InfoContainer className="dashboard-premium-view">
      <StyledCard className="mypage-card">
        <CardHeader as="h5">
          회사 정보
        </CardHeader>

        {/* <Card.Title className="border border-bottom-0 px-3 pt-3">  고객사 상세 정보</Card.Title> */}
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              {/* Left Column (Profile Image) */}
              <Col md={4} className="text-center profile-section">
                <div
                  {...getRootProps({ className: 'dropzone' })}
                  style={{
                    cursor: (userAuth === 'SA' || userAuth === 'ADMIN') ? 'pointer' : 'not-allowed',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '150px',
                    height: '150px',
                    position: 'relative',
                    margin: '0 auto'
                  }}
                // onMouseEnter={handleMouseEnter}
                // onMouseLeave={handleMouseLeave}
                >
                  <input {...getInputProps()} />

                  <Profile>
                    <Image
                      src={avatar.length > 0 ? avatar[0].src : cloudUpload}
                      alt=""
                    />
                    <HoverView>이미지 변경</HoverView>
                    {uploading && (
                      <div style={{
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: 'rgba(255,255,255,0.6)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}>
                        <Spinner animation="border" size="sm" />
                      </div>
                    )}
                  </Profile>
                </div>

              </Col>

              {/* Right Column (ID, Password, Name) */}
              <Col md={8}>
                <Row>
                  <Col>
                    <Form.Group
                      className="mb-3"
                      style={{ position: 'relative' }}
                    >
                      <Form.Label>
                        회사명<span className="text-danger">*</span>
                      </Form.Label>
                      <div style={{ position: 'relative' }}>
                        <Form.Control
                          type="text"
                          name="clientName"
                          value={formData.clientName}
                          onChange={handleChange}
                          disabled={userAuth != 'SA'}
                          className="input-hover"
                          maxLength="50"
                        // placeholder="아이디를 입력해주세요."
                        />

                        {formData.clientName && (
                          <span
                            onClick={e => {
                              handleValueDelete(
                                'clientName',
                                formData,
                                setFormData
                              );
                              handleChange({
                                target: { name: 'clientName', value: '' }
                              }); // handleChange를 직접 호출
                            }}
                            style={{
                              cursor: 'pointer',
                              position: 'absolute',
                              right: '10px',
                              top: '50%',
                              transform: 'translateY(-14px)',
                              zIndex: 9
                            }}
                          >
                            {/* 삭제 아이콘, SA 일때만 활성화 */}
                            {userAuth === 'SA' && <AiFillCloseCircle />}
                          </span>
                        )}
                      </div>
                    </Form.Group>
                    {NameError && (
                      <span className="text-danger">{NameError}</span>
                    )}{' '}
                    {/* 에러 메시지 표시 */}
                  </Col>
                  <Col>
                    <Form.Group
                      className="mb-3"
                      style={{ position: 'relative' }}
                    >
                      <Form.Label>
                        회사 연락처<span className="text-danger">*</span>
                      </Form.Label>

                      <div style={{ position: 'relative' }}>
                        <Form.Control
                          type="text"
                          name="clientPhone"
                          isInvalid={isInvalid}
                          value={formData.clientPhone}
                          onChange={handleChange}
                          className="input-hover"
                          disabled={userAuth === 'MANAGER'}
                          maxLength="20"
                        // placeholder="비밀번호를 입력해주세요."
                        />
                        {formData.clientPhone && userAuth !== 'MANAGER' && (
                          <span
                            onClick={e =>
                              handleValueDelete(
                                'clientPhone',
                                formData,
                                setFormData
                              )
                            }
                            style={{
                              cursor: 'pointer',
                              position: 'absolute',
                              right: '10px',
                              // top: isInvalid ? '35%' : '50%',
                              top: '50%',
                              transform: 'translateY(-14px)',
                              zIndex: 9
                            }}
                          >
                            <AiFillCloseCircle />
                          </span>
                        )}
                      </div>
                      <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                      {PhoneError && (
                        <span className="text-danger">{PhoneError}</span>
                      )}{' '}
                      {/* 에러 메시지 표시 */}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      className="mb-3"
                      style={{ position: 'relative' }}
                    >
                      <Form.Label>
                        회사 메일<span className="text-danger">*</span>
                      </Form.Label>
                      <div style={{ position: 'relative' }}>
                        <Form.Control
                          type="text"
                          name="clientEmail"
                          value={formData.clientEmail}
                          onChange={handleChange}
                          className="input-hover"
                          disabled={userAuth === 'MANAGER'}
                          maxLength="50"

                        // placeholder="이름을 입력해주세요."
                        />

                        {formData.clientEmail && userAuth !== 'MANAGER' && (
                          <span
                            onClick={e =>
                              handleValueDelete(
                                'clientEmail',
                                formData,
                                setFormData
                              )
                            }
                            style={{
                              cursor: 'pointer',
                              position: 'absolute',
                              right: '10px',
                              top: '50%',
                              transform: 'translateY(-14px)',
                              zIndex: 9
                            }}
                          >
                            <AiFillCloseCircle />
                          </span>
                        )}
                      </div>
                      {MailError && (
                        <span className="text-danger">{MailError}</span>
                      )}{' '}
                      {/* 에러 메시지 표시 */}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      className="mb-3"
                      style={{ position: 'relative' }}
                    >
                      <Form.Label>
                        회사 주소<span className="text-danger">*</span>
                      </Form.Label>
                      <div style={{ position: 'relative' }}>
                        <Form.Control
                          type="text"
                          name="clientAddress"
                          value={formData.clientAddress}
                          onChange={handleChange}
                          className="input-hover"
                          disabled={userAuth === 'MANAGER'}
                          maxLength="100"

                        // placeholder="이름을 입력해주세요."
                        />

                        {formData.clientAddress && userAuth !== 'MANAGER' && (
                          <span
                            onClick={e =>
                              handleValueDelete(
                                'clientAddress',
                                formData,
                                setFormData
                              )
                            }
                            style={{
                              cursor: 'pointer',
                              position: 'absolute',
                              right: '10px',
                              top: '50%',
                              transform: 'translateY(-14px)',
                              zIndex: 9
                            }}
                          >
                            <AiFillCloseCircle />
                          </span>
                        )}
                      </div>
                    </Form.Group>
                    {AddrError && (
                      <span className="text-danger">{AddrError}</span>
                    )}{' '}
                    {/* 에러 메시지 표시 */}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>등록 일시</Form.Label>
                      <Form.Control
                        type="text"
                        name="addDate"
                        value={formatDate(formData.createdAt)}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>수정 일시</Form.Label>
                      <Form.Control
                        type="text"
                        name="editDate"
                        value={formatDate(formData.updateAt)}
                        readOnly
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <div style={{ display: 'none' }}>
                  <div
                    style={{
                      width: '100%',
                      backgroundColor: 'lightgray',
                      display: 'flex',
                      justifyContent: 'space-between'
                    }}
                  >
                    <span>
                      <h5>[{formData.clientName}] KEY 관리</h5>
                    </span>
                    <button
                      style={{ border: 'none', backgroundColor: 'transparent' }}
                      onClick={toggleKeyPart} // 상태 변경 함수 호출
                    >
                      {isChevronUp ? <BsChevronDown /> : <BsChevronUp />}{' '}
                      {/* 아이콘 상태에 따라 표시 */}
                    </button>
                  </div>
                  {KeyPart && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        border: '2px',
                        borderStyle: 'dashed'
                      }}
                      className="p-2"
                    >
                      <div style={{ flexGrow: 1 }} className="mb-4">
                        <Row className="align-items-center">
                          <Col md={9}>
                            <Form.Group
                              className="mb-3"
                              style={{ position: 'relative' }}
                            >
                              <Form.Label>
                                [{formData.clientName}] SECRET
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="clientSecret"
                                value={formData.clientSecret}
                                onChange={handleChange}
                                readOnly
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ opacity: 0 }}>
                                버튼
                              </Form.Label>
                              <Button variant="secondary" className="w-100">
                                SECRET 재발급
                              </Button>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="align-items-center">
                          <Col md={9}>
                            <Form.Group
                              className="mb-3"
                              style={{ position: 'relative' }}
                            >
                              <Form.Label>암호용 KEY</Form.Label>
                              <Form.Control
                                type="text"
                                name="clientKey"
                                value={formData.clientKey}
                                onChange={handleChange}
                                readOnly
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group
                              className="mb-3"
                              style={{ position: 'relative' }}
                            >
                              <Form.Label style={{ opacity: 0 }}>
                                버튼
                              </Form.Label>
                              <Button
                                variant="secondary"
                                className="w-100 p-0"
                                style={{ height: 36, fontSize: 16 }}
                              >
                                암호용KEY/Ⅳ 재발급
                              </Button>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={9}>
                            <Form.Group
                              className="mb-3"
                              style={{ position: 'relative' }}
                            >
                              <Form.Label>암호용 Ⅳ</Form.Label>
                              <Form.Control
                                type="text"
                                name="clientIV"
                                value={formData.clientIV}
                                onChange={handleChange}
                                readOnly
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                </div>

                <Form.Group className="mb-3" style={{ position: 'relative' }}>
                  <Form.Label>설명</Form.Label>
                  <div style={{ position: 'relative' }}>
                    <Form.Control
                      as="textarea"
                      name="description"
                      rows={3}
                      value={formData.description}
                      onChange={handleChange}
                      className="input-hover"
                      maxLength="200"
                      disabled={userAuth === 'MANAGER'}
                    />
                    {formData.description && userAuth !== 'MANAGER' && (
                      <span
                        onClick={e =>
                          handleValueDelete(
                            'description',
                            formData,
                            setFormData
                          )
                        }
                        style={{
                          cursor: 'pointer',
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-14px)',
                          zIndex: 9
                        }}
                      >
                        <AiFillCloseCircle />
                      </span>
                    )}
                  </div>
                  {DescError && <div style={{ color: 'red' }}>{DescError}</div>}{' '}
                  {/* 에러 메시지 표시 */}
                </Form.Group>
              </Col>
            </Row>

            {/* 키영역 복구 시 pt 빼도됨*/}
            <div className="d-flex justify-content-end mt-3 pt-8">
              {/* <Button variant="secondary" className='mx-3' style={{ width: '8rem' }}>
                관리 키 설정
              </Button> */}
              <Button
                variant="primary"
                type="submit"
                onClick={handleSubmitClick}
                disabled={!isFormValid() || userAuth === 'MANAGER'}
                style={{ width: '8rem' }}
              >
                변경
              </Button>
            </div>
          </Form>
        </Card.Body>
      </StyledCard>

      {/* 요금정책 정보 Card 추가 */}
      <StyledCard className="mt-3">
        <CardHeader as="h5">요금정책 정보</CardHeader>
        <Card.Body>
          <Form>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>요금정책명</Form.Label>
                  <Form.Control
                    type="text"
                    value={pricingPolicyName || '적용된 요금정책 없음'}
                    disabled
                    readOnly
                    className="bg-light"
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* 요금정책 상세 정보 섹션 - 항상 표시 */}
            {pricingPolicyUuid && (
              <div>
                {loadingPolicyDetails ? (
                  <div className="text-center py-4">
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                    <p className="mt-2">요금정책 정보를 로딩 중입니다...</p>
                  </div>
                ) : policyDetails ? (
                  <div className="policy-details border rounded p-3 bg-light">
                    <h6 className="border-bottom pb-2 mb-3">정책 기본 정보</h6>
                    <Row className="mb-3">
                      <Col md={parseFloat(policyDetails.compensationAmount) > 0 ? 4 : 6}>
                        <Form.Group>
                          <Form.Label>정책명</Form.Label>
                          <Form.Control
                            type="text"
                            value={policyDetails.pricingPolicyName || '-'}
                            readOnly
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col md={parseFloat(policyDetails.compensationAmount) > 0 ? 4 : 6}>
                        <Form.Group>
                          <Form.Label>설명</Form.Label>
                          <Form.Control
                            type="text"
                            value={policyDetails.description || '-'}
                            readOnly
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      {parseFloat(policyDetails.compensationAmount) > 0 && (
                        <Col md={4}>
                          <Form.Group>
                            <Form.Label>정책 보전금액</Form.Label>
                            <Form.Control
                              type="text"
                              value={formatCurrency(policyDetails.compensationAmount)}
                              readOnly
                              disabled
                            />
                          </Form.Group>
                        </Col>
                      )}
                    </Row>

                    {policyDetails.serviceGroupList && policyDetails.serviceGroupList.length > 0 ? (
                      <>
                        <h6 className="border-bottom pb-2 mb-3 mt-4">서비스 구성</h6>
                        {policyDetails.serviceGroupList.map((group, index) => (
                          <div key={index} className="service-group mb-4 border rounded p-3 bg-white">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h6 className="mb-0">서비스 그룹: {group.serviceItemName || '-'}</h6>
                              {parseFloat(group.compensationAmount) > 0 && (
                                <span className="text-muted" style={{ fontSize: '0.85rem' }}>
                                  그룹 보전금액: <strong>{formatCurrency(group.compensationAmount)}</strong>
                                </span>
                              )}
                            </div>

                            {group.servicePriceList && group.servicePriceList.length > 0 ? (
                              <>
                                {group.servicePriceList.map((servicePrice, priceIndex) => (
                                  <div key={priceIndex} className="service-price ms-3 mb-3">
                                    <p className="mb-2 mt-3"><strong>서비스 항목:</strong> {servicePrice.serviceItemName || '-'}</p>
                                    <Row className="mb-2">
                                      <Col md={parseFloat(servicePrice.compensationAmount) > 0 ? 4 : 6}>
                                        <Form.Group>
                                          <Form.Label>기본 가격</Form.Label>
                                          <Form.Control
                                            type="text"
                                            value={formatCurrency(servicePrice.price)}
                                            readOnly
                                            disabled
                                          />
                                        </Form.Group>
                                      </Col>
                                      <Col md={parseFloat(servicePrice.compensationAmount) > 0 ? 4 : 6}>
                                        <Form.Group>
                                          <Form.Label>결제 단위</Form.Label>
                                          <Form.Control
                                            type="text"
                                            value={servicePrice.paymentUnit || '-'}
                                            readOnly
                                            disabled
                                          />
                                        </Form.Group>
                                      </Col>
                                      {parseFloat(servicePrice.compensationAmount) > 0 && (
                                        <Col md={4}>
                                          <Form.Group>
                                            <Form.Label>항목 보전금액</Form.Label>
                                            <Form.Control
                                              type="text"
                                              value={formatCurrency(servicePrice.compensationAmount)}
                                              readOnly
                                              disabled
                                            />
                                          </Form.Group>
                                        </Col>
                                      )}
                                    </Row>

                                    {servicePrice.serviceTierPriceList && servicePrice.serviceTierPriceList.length > 0 && (
                                      <div className="tier-pricing mt-3">
                                        <h6 className="mb-2">구간 가격 정보</h6>
                                        <Table bordered hover size="sm" className="fs-10">
                                          <thead className="bg-light">
                                            <tr>
                                              <th>시작 수량</th>
                                              <th>종료 수량</th>
                                              <th>할인 수치</th>
                                              <th>할인 단위</th>
                                              <th>적용 가격</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {servicePrice.serviceTierPriceList.map((tier, tierIndex) => {
                                              // Calculate discounted price
                                              let discountedPrice = servicePrice.price;
                                              if (tier.discountUnit === 'percent') {
                                                discountedPrice = servicePrice.price * (1 - tier.discountAmount / 100);
                                              } else if (tier.discountUnit === 'won') {
                                                discountedPrice = servicePrice.price - tier.discountAmount;
                                              }

                                              return (
                                                <tr key={tierIndex}>
                                                  <td>{tier.startAmount}</td>
                                                  <td>{tier.endAmount}</td>
                                                  <td>{tier.discountAmount}</td>
                                                  <td>{tier.discountUnit === 'percent' ? '%' : '원'}</td>
                                                  <td>{formatCurrency(discountedPrice)}</td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </Table>
                                      </div>
                                    )}
                                    {priceIndex < group.servicePriceList.length - 1 && (
                                      <hr className="my-3" />
                                    )}
                                  </div>
                                ))}
                              </>
                            ) : (
                              <p className="ms-3 text-muted">서비스 가격 정보가 없습니다.</p>
                            )}
                          </div>
                        ))}
                      </>
                    ) : (
                      <p className="text-muted">서비스 구성 정보가 없습니다.</p>
                    )}

                    {hasAnyCompensation() && (
                      <div className="border rounded p-2 px-3 mt-3" style={{ backgroundColor: '#f0fdf4', borderColor: '#bbf7d0' }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="fw-semibold" style={{ color: '#166534', fontSize: '0.85rem' }}>기본 청구 금액 (보전금액 총합)</span>
                          <span className="fw-bold" style={{ color: '#166534', fontSize: '1rem' }}>
                            {formatCurrency(calculateTotalCompensation())}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <p className="text-danger">요금정책 정보를 불러올 수 없습니다.</p>
                )}
              </div>
            )}

            {!pricingPolicyUuid && (
              <div className="text-center py-4">
                <p className="text-muted">적용된 요금정책이 없습니다.</p>
              </div>
            )}
          </Form>
        </Card.Body>
      </StyledCard>

      <CheckOutModal
        show={resultShow}
        onHide={() => setResultShow(false)}
        onConfirm={() => setResultShow(false)}
        title="완료"
        body="정상 등록되었습니다."
        confirmText="확인"
        variant='success'
        SubmitButton={true}
      />


      <CheckOutModal
        show={modalConfirmShow}
        onHide={() => setModalConfirmShow(false)}
        onConfirm={handleConfirm}
        title="확인" // 제목
        variant="info"
        body="변경하신 사항으로 계정 정보를 수정하시겠습니까?" // 본문 내용
        cancelText="취소" // 취소 버튼 텍스트
        confirmText="확인" // 확인 버튼 텍스트
        CancelButton={true}
        SubmitButton={true}
      />

      <CheckOutModal
        show={modalConfirmCheckShow}
        onHide={() => setModalConfirmCheckShow(false)}
        variant="success"
        onConfirm={() => setModalConfirmCheckShow(false)}
        title="확인" // 제목
        body="변경하신 사항이 해당 계정 정보에 저장되었습니다." // 본문 내용
        confirmText="확인" // 확인 버튼 텍스트
        SubmitButton={true}
      />
    </InfoContainer>
  );
};

export default SiteInfo;

const Profile = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const HoverView = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: white;
  transition: all 0.1s;
  background-color: #2229;
  user-select: none;
  opacity: 0;

  &:hover {
    opacity: 1;
  }
`;
